import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import AddLiaisonOfficer from "../../pages/AddLiaisonOfficer/AddLiaisonOfficer";
import AuthStore from "../../store/AuthStore";
import SettingsStore from "../../store/SettingsStore";

const CheckLiasionOfficer = () => {
  const navigate = useNavigate();
  const isHydated = SettingsStore.isHydrated;

  useEffect(() => {
    if (SettingsStore.isHydrated) {
      if (!SettingsStore.liaisonOfficerData) {
        AuthStore.updateLoadingFullScreen(true);
        navigate("/settings", { state: { from: "liaison_office_access" } });
      } else {
        navigate("/settings/edit-family-office-team", {
          state: { from: "liaison_office_access" },
        });
      }
    }
    // eslint-disable-next-line
  }, [isHydated]);

  return (
    <div>
      <AddLiaisonOfficer />
    </div>
  );
};

export default CheckLiasionOfficer;
